import gql from 'graphql-tag';


const CHANGE_PRICE_QUEUE_TYPE = gql`
	mutation changePriceQueueType (
		$id: ID!
		$queuedPriceType: Int,
	) {
		changePriceQueueType(
			id: $id
			queuedPriceType: $queuedPriceType,
		) {
			id
			price
			queuedPrice
			queuedPriceType
		}
	}
`;

export default CHANGE_PRICE_QUEUE_TYPE;

